import { useSelector } from 'react-redux';
import { useIsActive as useIsActiveModules } from '../../hooks';
import { MODULE_NAME } from './constants';
import { emptyArray } from '../../../shared/misc';

export const useIsActive = () => useIsActiveModules(MODULE_NAME);

export const useGetPage = () => {
  const { pages = emptyArray } = useSelector((state) => state.appState.settings);
  return (path) => pages.find((el) => el.route?.path === path);
};
